import styled from "styled-components";

export const TabelaCalculadora = styled.table`
  background-color: #fff;
  color: black;
  margin-bottom: 40px;
  border-radius: 4px;

  width: 100%;
  border-collapse: collapse;
  padding: 1rem;

  th {
    border: 1px solid;
    border-radius: 2px;
    padding: 0.5rem;
  }

  @media (max-width: 768px) {
    font-size: 0.85rem;
  }
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: flex-start;

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  @media (max-width: 768px) {
    padding: 0 1rem;
  }
`;

export const FormWrapper = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  padding: 1.5rem;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const StyledInput = styled.input`
  width: 100%;
  padding: 0.6rem 0.8rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-top: 4px;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: #007aff;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 0.5rem 0.7rem;
  }
`;

export const ResultadoWrapper = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  overflow-x: auto;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const Tabela = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  min-width: 400px;

  th,
  td {
    border-bottom: 1px solid #eee;
    padding: 0.5rem;
    text-align: left;
    white-space: nowrap;
  }

  th {
    color: #555;
    font-weight: 600;
  }

  @media (max-width: 768px) {
    font-size: 0.85rem;
    th,
    td {
      padding: 0.4rem 0.3rem;
    }
  }
`;

export const Resumo = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
  font-size: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.3rem;
    font-size: 0.9rem;
  }
`;

export const ResumoFinal = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  span {
    color: #777;
  }

  strong {
    font-size: 1.2rem;
  }

  @media (max-width: 768px) {
    strong {
      font-size: 1rem;
    }
  }
`;

export const Economia = styled.div<{ positivo: boolean }>`
  margin-top: 0.5rem;
  color: ${({ positivo }) => (positivo ? "#10b981" : "#ef4444")};
  font-weight: bold;
`;

export const ErrorMessage = styled.p`
  color: #ef4444;
  font-size: 0.9rem;
  margin: 0.5rem 0;

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`;
